/* eslint-disable  */
//@ts-nocheck
import { Box, LinearProgress } from '@mui/material';
import React from 'react';
import uploadCloudIcon from '/static/images/icon-upload-cloud.svg';

class ProgressBar extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { completed } = this.props;

    const containerStyles = {
      height: 10,
      borderRadius: 50,
      margin: '68px auto',
      minWidth: '400px',
    };

    const headerInfoStyles = {
      display: 'flex',
      flexDirection: 'row',
      fontSize: '16px',
      fontWeight: 600,
      marginTop: '-26px',
      alignItems: 'center',
    };

    const progressTextStyles = {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      fontSize: '12px',
      fontWeight: 400,
      color: '#8F9BB3',
    };

    return (
      <div style={containerStyles}>
        <div style={headerInfoStyles}>
          <img
            src={uploadCloudIcon}
            style={{ height: '12px', margin: 'auto 5px' }}
          ></img>
          <span style={{ marginRight: 'auto' }}>{this.props.title}</span>
          <button
            onClick={this.props.cancelUpload}
            style={{
              border: '1px solid #FFFFFF',
              borderRadius: '20px',
              background: '#FAF0F0',
              color: '#FA5D5D',
              outline: 'none',
              textDecoration: 'none',
              fontSize: '12px',
              padding: '3px 12px',
            }}
          >
            Cancel
          </button>
        </div>
        <Box sx={{ width: '100%', marginTop: '5px' }}>
          <LinearProgress variant="determinate" value={completed} />
          <div style={progressTextStyles}>Uploading...</div>
        </Box>
      </div>
    );
  }
}

export default ProgressBar;
